import React from "react";
import "../../styles/atoms.scss";
import aboutDesktop from "../../assets/about/about-img01.png";
import aboutMobile from "../../assets/about/about-img02.png";

const About = () => {
  return (
    <div className="static-hero">
      <h1 className="big-title">
        A place that UX/UI Designers could call <span>Home!</span>
      </h1>

      <div className="static-content">
        <h2 className="title">Our Story</h2>
        <p>
          UUD originated as a vibrant UXUI Design community in Tokyo, Japan,
          managed by a international team primarily consisting of UXUI
          Designers, including the founder.
          <br />
          Our story began as a local hub for UXUI designers, organizing offline
          activities such as events, workshops, and meetups.
        </p>

        <div className="image-container">
          <picture>
            <source media="(max-width: 640px)" srcSet={aboutMobile} />
            <img src={aboutDesktop} alt="UUD Community Event" loading="lazy" />
          </picture>
        </div>

        <p>
          As passionate UXUI designers ourselves, we immersed ourselves in the community,
          gaining valuable insights into their needs, challenges, and aspirations.
          <br /><br />
          This firsthand experience inspired us to develop a platform that could cater to all these aspects and create an ideal space for UXUI Designers—a place they could truly call HOME!<br />
          Our motto, "A place UXUI designers could call HOME!" encapsulates our mission.
          We aim to make UUD a comprehensive hub where UXUI designers can find everything they need in one place: educational content, diverse resources, information, inspiration, and networking opportunities.
          Our goal is to fuel their creativity and enhance their skills, providing a supportive environment to thrive.
        </p>

        <p>
          At UUD, we are more than just a platform; we are a passionate community of UXUI designers, founded by designers and run for designers.
          Our platform not only offers a wide range of services and resources but also reflects the experiences and aspirations of the UXUI design community.
          <br /><br />
          At UUD, we are more than just a platform; we are a passionate community of UXUI designers, founded by designers and run for designers.
          Our platform not only offers a wide range of services and resources but also reflects the experiences and aspirations of the UXUI design community.
          <br /><br />
          With a solid foundation rooted in understanding the UXUI design community deeply, we provide an array of services, tools, and resources.
          Moreover, we eagerly listen to our users, addressing their specific needs and aspirations directly.<br />
          We invite you to join us on this transformative journey, whether you are a seasoned UXUI Designer,
          a newcomer embarking on their UXUI Design path, or even someone without a design background but deeply passionate about UXUI Design, just like us.
          In UUD, you will find the support and resources you need to excel.
        </p>
      </div>
    </div>
  );
};

export default About;
